import {action, observable, runInAction} from "mobx";
import {IArenaGameFilterEditorViewModel} from "./arena-game-filter-editor-view-model.interface";
import {IArenaGameFilter} from "./arena-game-filter.interface";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {ArenaGameFiltersCategoryEditor} from "../categories/arena-game-filters-category-editor";

export class ArenaGameFilterEditor implements IArenaGameFilterEditorViewModel {
    constructor(protected readonly arenaGameFilter: IArenaGameFilter,
                protected readonly categoryEditor?: ArenaGameFiltersCategoryEditor) {
        this._on = arenaGameFilter.isApplied;
    }

    get id(): string {
        return this.arenaGameFilter.id;
    }

    get text(): string {
        return this.arenaGameFilter.text;
    }

    @observable.ref
    protected _on: boolean = false;
    get on(): boolean {
        return this._on;
    }

    set on(value: boolean) {
        this._setOn(value);
    }

    protected _resetOtherFiltersInTheCategory(): void {
        this.categoryEditor.visibleFilters.forEach(f => {
            if(f.id !== this.id) {
                f.on = false;
            }
        })
    }

    protected _setOn(value: boolean): void {

        if(value && this.categoryEditor && !this.categoryEditor.isMultiSelect) {
           this._resetOtherFiltersInTheCategory();
        }

        runInAction(() => this._on = value);
    }

    get disabled(): boolean {
        return false;
    }

    @action.bound
    toggleFilter(): void {
        this.on = !this.on;
    }

    get shouldBeDisplayed(): boolean {
        return !this.arenaGameFilter.isAdhocFilter;
    }

    get gamesCount(): NullableNumber {
        return this.arenaGameFilter.gamesCount;
    }


    private _subFilters: ArenaGameSubFilterEditor[] | null = null;
    get subFilters(): ArenaGameSubFilterEditor[] {
        if(!this._subFilters) {
            this._subFilters = this.arenaGameFilter.subFilters.map(sf => new ArenaGameSubFilterEditor(this, sf));
        }
        return this._subFilters;
    }
}


export class ArenaGameSubFilterEditor extends ArenaGameFilterEditor {
    constructor(private readonly parent: ArenaGameFilterEditor,
                arenaGameFilter: IArenaGameFilter) {
        super(arenaGameFilter)
    }

    get on(): boolean {
        return this._on && this.parent.on;
    }

    set on(value: boolean) {
        this._setOn(value);
    }

    get disabled(): boolean {
        return !this.parent.on;
    }
}